import { NgModule } from '@angular/core';

import {
    BreadCrumbModule,
    ButtonModule,
    CarouselModule,
    HeroModule,
    IconsModule,
    ModalModule,
    NotificationModule,
    OptionsModule,
    PriceModule,
    RatingModule,
    SliderModule,
    StickyModule,
    TabsModule,
    ToggleModule,
    ZoomModule,
} from '@trilogy';

@NgModule({
    declarations: [],

    imports: [
        CarouselModule,
        ButtonModule,
        IconsModule,
        ZoomModule,
        ModalModule,
        HeroModule,
        PriceModule,
        NotificationModule,
        TabsModule,
        RatingModule,
        StickyModule,
        SliderModule,
        BreadCrumbModule,
        OptionsModule,
        ToggleModule,
    ],

    exports: [
        CarouselModule,
        ButtonModule,
        IconsModule,
        ZoomModule,
        ModalModule,
        HeroModule,
        PriceModule,
        NotificationModule,
        TabsModule,
        RatingModule,
        StickyModule,
        SliderModule,
        BreadCrumbModule,
        OptionsModule,
    ],
})
export class TrilogyComponentsModule {}
